module.exports = __webpack_public_path__ + "static/img/btn.9f07dabe.png";